module.exports = __webpack_public_path__ + "img/daishenhe.8f65a8aa.png";